import { Component } from '@angular/core';
import { Wrap } from './Wrap';

@Component({
  selector: 'Main',
  imports: [Wrap],
  template: `
    <main class="my-section">
      <Wrap>
        <ng-content></ng-content>
      </Wrap>
    </main>
  `,
})
export class Main {}
